import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import LoadingProgress from '../components/LoadingProgress'

import {
  fetchSupportTickets,
  fetchSupportTicket,
  closeTicketSupport,
  reviewTicketSupport,
  resolveTicketSupport,
  incidenceTicketSupport,
  repairTicketSupport,
  deleteSupportTicket
} from '../actions/supporttickets'

import ErrorMessage from '../components/ErrorMessage'
import SupportTicketsFilterForm from '../forms/SupportTicketsFilterForm'

import '../styles/SupportTicketAdminView.css'

const STATUS_LABELS = {
  OPEN: 'Abierto',
  IN_REVIEW: 'En Revisión',
  IN_INCIDENCE: 'En Incidencia',
  IN_REPAIR: 'En Reparación',
  RESOLVED: 'Resuelto',
  CLOSED: 'Cerrado',
}

const PRIORITY_LABELS = {
  LOW: 'Baja',
  MEDIUM: 'Media',
  HIGH: 'Alta',
  CRITICAL: 'Crítica',
}

const CATEGORY_LABELS = {
  COINS: 'Pago Monedas',
  BILLS: 'Pago Billetes',
  TPV: 'Pago Tarjeta',
  SCREEN_OFF: 'Pantalla Apagada',
  SCREEN_BREAK: 'Pantalla Rota',
  SCREEN_TOUCH: 'Táctil No Responde',
  PRINTER_TICKET: 'Impresora Ticket',
  KIOSC_DOOR: 'Kiosco Puerta',
  KIOSC_OFF: 'Kiosco No Enciende',
  OTHER: 'Otro',
}

const FILTER_TABS = [
  { key: 'ALL', label: 'Todos' },
  { key: 'OPEN', label: 'Abiertos' },
  { key: 'IN_REVIEW', label: 'En Revisión' },
  { key: 'IN_INCIDENCE', label: 'En Incidencia' },
  { key: 'IN_REPAIR', label: 'En Reparación' },
  { key: 'RESOLVED', label: 'Resueltos' },
  { key: 'CLOSED', label: 'Cerrados' },
]

class SupportTicketsView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      activeFilter: 'ALL',
      closeConfirmShown: false,
      closeId: null,
      detailModalOpen: false,
      detailId: null,
      deleteConfirmShown: false,
      deleteId: null,
      actuationText: '',
      showActuationModal: false,
      actuationAction: null, // 'resolve' or 'incidence'
    }

    this.handleDownload = this.handleDownload.bind(this)
    this.confirmClose = this.confirmClose.bind(this)
    this.confirmDelete = this.confirmDelete.bind(this)
    this.closeDetailModal = this.closeDetailModal.bind(this)
    this.handleActuationSubmit = this.handleActuationSubmit.bind(this)
  }

  componentDidMount() {
    this.props.fetchSupportTickets('', '', '', '', '', '')
  }

  componentDidUpdate(prevProps) {
    if (this.props.supportticketNeedRefresh && !prevProps.supportticketNeedRefresh) {
      this.props.fetchSupportTickets('', '', '', '', '', '')
      // also refresh the open detail if any
      if (this.state.detailId) {
        this.props.fetchSupportTicket(this.state.detailId)
      }
    }
  }

  getStatusCounts() {
    const { supporttickets } = this.props
    if (!supporttickets) return {}
    return supporttickets.reduce((acc, t) => {
      acc[t.Status] = (acc[t.Status] || 0) + 1
      return acc
    }, {})
  }

  getCategoryCounts() {
    const { supporttickets } = this.props
    if (!supporttickets) return {}
    return supporttickets.reduce((acc, t) => {
      acc[t.Category] = (acc[t.Category] || 0) + 1
      return acc
    }, {})
  }

  getPriorityCounts() {
    const { supporttickets } = this.props
    if (!supporttickets) return {}
    return supporttickets.reduce((acc, t) => {
      acc[t.Priority] = (acc[t.Priority] || 0) + 1
      return acc
    }, {})
  }

  getFilteredTickets() {
    const { supporttickets } = this.props
    const { activeFilter } = this.state
    if (!supporttickets) return []
    if (activeFilter === 'ALL') return supporttickets
    return supporttickets.filter(t => t.Status === activeFilter)
  }

  handleDownload() {
    const { supporttickets } = this.props
    if (!supporttickets || supporttickets.length === 0) return

    const headers = ['#', 'Fecha Apertura', 'Fecha Cierre', 'Cliente', 'Máquina', 'Categoría', 'Descripción', 'Actuación', 'Estado', 'Prioridad', 'Ejecutor', 'Cerrado por']
    const rows = supporttickets.map(t => [
      t.number,
      new Date(t.OpenAt).toLocaleString(),
      t.ClosedAt ? new Date(t.ClosedAt).toLocaleString() : '',
      t.Customer && t.Customer.Fullname ? t.Customer.Fullname : 'VACWAY',
      t.Machine ? t.Machine.Serial : '',
      t.Category,
      t.Description ? t.Description.replace(/[\n\r,;]/g, ' ') : '',
      t.Actuation ? t.Actuation.replace(/[\n\r,;]/g, ' ') : '',
      t.Status,
      t.Priority,
      t.Executor ? t.Executor.fullname : '',
      t.ClosedBy ? t.ClosedBy.fullname : ''
    ])

    const csvContent = [headers, ...rows].map(row =>
      row.map(cell => `"${cell}"`).join(';')
    ).join('\n')

    const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = `tickets_soporte_${new Date().toISOString().substring(0, 10)}.csv`
    link.click()
    URL.revokeObjectURL(url)
  }

  goTo(id) {
    this.setState({ detailModalOpen: true, detailId: id })
    this.props.fetchSupportTicket(id)
  }

  closeDetailModal() {
    this.setState({ detailModalOpen: false, detailId: null, actuationText: '' })
  }

  handleReviewTicket(id, e) {
    if (e) e.stopPropagation()
    this.props.reviewTicketSupport(id)
  }

  // Open actuation modal for resolve action
  handleOpenResolveModal(id, e) {
    if (e) e.stopPropagation()
    this.setState({ 
      showActuationModal: true, 
      actuationAction: 'resolve',
      actuationText: ''
    })
  }

  // Open actuation modal for incidence action
  handleOpenIncidenceModal(id, e) {
    if (e) e.stopPropagation()
    this.setState({ 
      showActuationModal: true, 
      actuationAction: 'incidence',
      actuationText: ''
    })
  }

  handleActuationSubmit() {
    const { actuationAction, actuationText, detailId } = this.state
    
    if (!actuationText.trim()) {
      alert('Por favor, introduce el texto de actuación')
      return
    }

    if (actuationAction === 'resolve') {
      this.props.resolveTicketSupport(detailId, actuationText)
    } else if (actuationAction === 'incidence') {
      this.props.incidenceTicketSupport(detailId, actuationText)
    }

    this.setState({ 
      showActuationModal: false, 
      actuationAction: null, 
      actuationText: '' 
    })
  }

  handleRepairTicket(id, e) {
    if (e) e.stopPropagation()
    this.props.repairTicketSupport(id)
  }

  handleCloseTicket(id, e) {
    if (e) e.stopPropagation()
    this.setState({ closeConfirmShown: true, closeId: id })
  }

  confirmClose() {
    this.setState({ closeConfirmShown: false })
    this.props.closeTicketSupport(this.state.closeId)
  }

  handleDeleteTicket(id, e) {
    if (e) e.stopPropagation()
    this.setState({ deleteConfirmShown: true, deleteId: id })
  }

  confirmDelete() {
    const id = this.state.deleteId
    this.setState({ deleteConfirmShown: false, deleteId: null })
    this.props.deleteSupportTicket(id)
    // close detail modal if open
    if (this.state.detailId === id) {
      this.closeDetailModal()
    }
  }

  renderTicketCard(ticket) {
    const statusLabel = STATUS_LABELS[ticket.Status] || ticket.Status
    const priorityLabel = PRIORITY_LABELS[ticket.Priority] || ticket.Priority
    const categoryLabel = CATEGORY_LABELS[ticket.Category] || ticket.Category

    return (
      <div className="st-admin-ticket-card" key={ticket._id}
        onClick={() => this.goTo(ticket._id)}>
        <div className="st-admin-ticket-row">
          <div className={`st-admin-status-bar ${ticket.Status}`}></div>
          <div className="st-admin-ticket-content">
            <div className="st-admin-ticket-info">
              <div className="st-admin-ticket-number">#{ticket.number}</div>
              <div className="st-admin-ticket-meta">
                <span><i className="fas fa-calendar-alt"></i>
                  {new Date(ticket.OpenAt).toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' })}
                </span>
                <span><i className="fas fa-tag"></i>{categoryLabel}</span>
              </div>
            </div>

            <div className="st-admin-ticket-context">
              <div className="st-admin-context-item">
                <i className="fas fa-building"></i>
                <strong>{ticket.Customer && ticket.Customer.Fullname ? ticket.Customer.Fullname : 'VACWAY'}</strong>
              </div>
              <div className="st-admin-context-item">
                <i className="fas fa-hdd"></i>
                {ticket.Machine ? ticket.Machine.Serial : 'N/A'}
              </div>
              {ticket.Executor &&
                <div className="st-admin-context-item">
                  <i className="fas fa-user-cog"></i>
                  {ticket.Executor.fullname}
                </div>
              }
            </div>

            <div className="st-admin-ticket-desc">
              {ticket.Description
                ? <span className="desc-text">{ticket.Description}</span>
                : <span className="desc-empty">Sin descripción</span>
              }
            </div>

            <div className="st-admin-ticket-badges">
              <span className={`ticket-status-badge ${ticket.Status}`}>
                {statusLabel}
              </span>
              <span className={`ticket-priority-badge ${ticket.Priority}`}>
                {priorityLabel}
              </span>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderDetailModal() {
    const { supportticket, role, type } = this.props
    const { detailModalOpen, showActuationModal, actuationAction, actuationText } = this.state

    if (!detailModalOpen) return null

    const isLoading = !supportticket
    const isAdmin = role === 'ADMIN'
    const isMaster = type === 'MASTER'
    const isClosed = supportticket && supportticket.Status === 'CLOSED'

    return (
      <>
        <Modal isOpen={detailModalOpen} toggle={this.closeDetailModal}
          className="st-detail-modal" size="xl">
          <ModalHeader toggle={this.closeDetailModal} className="st-detail-modal-header">
            {supportticket
              ? <span><i className="fas fa-ticket-alt"></i> Ticket #{supportticket.number}</span>
              : <span><i className="fas fa-ticket-alt"></i> Cargando...</span>
            }
          </ModalHeader>
          <ModalBody className="st-detail-modal-body">
            {isLoading ? <LoadingProgress /> : (
              <>
                {/* Badges */}
                <div className="st-modal-badges-row">
                  <span className={`ticket-status-badge ${supportticket.Status}`}>
                    {STATUS_LABELS[supportticket.Status] || supportticket.Status}
                  </span>
                  <span className={`ticket-priority-badge ${supportticket.Priority}`}>
                    {PRIORITY_LABELS[supportticket.Priority] || supportticket.Priority}
                  </span>
                </div>

                {/* Info grid */}
                <div className="st-modal-detail-grid">
                  <div className="st-detail-card">
                    <div className="st-detail-card-title">
                      <i className="fas fa-info-circle"></i> Información General
                    </div>
                    <div className="st-detail-card-body">
                      <div className="st-detail-field">
                        <span className="st-detail-field-label">Número</span>
                        <span className="st-detail-field-value">#{supportticket.number}</span>
                      </div>
                      <div className="st-detail-field">
                        <span className="st-detail-field-label">Categoría</span>
                        <span className="st-detail-field-value">{CATEGORY_LABELS[supportticket.Category] || supportticket.Category}</span>
                      </div>
                      <div className="st-detail-field">
                        <span className="st-detail-field-label">Cliente</span>
                        <span className="st-detail-field-value">{supportticket.Customer && supportticket.Customer.Fullname ? supportticket.Customer.Fullname : 'VACWAY'}</span>
                      </div>
                      <div className="st-detail-field">
                        <span className="st-detail-field-label">Máquina</span>
                        <span className="st-detail-field-value">{supportticket.Machine ? supportticket.Machine.Serial : 'N/A'}</span>
                      </div>
                      <div className="st-detail-field">
                        <span className="st-detail-field-label">Creado por</span>
                        <span className="st-detail-field-value">{supportticket.User ? supportticket.User.fullname : 'N/A'}</span>
                      </div>
                    </div>
                  </div>

                  <div className="st-detail-card">
                    <div className="st-detail-card-title">
                      <i className="fas fa-calendar"></i> Fechas y Asignaciones
                    </div>
                    <div className="st-detail-card-body">
                      <div className="st-detail-field">
                        <span className="st-detail-field-label">Fecha Apertura</span>
                        <span className="st-detail-field-value">{new Date(supportticket.OpenAt).toLocaleString()}</span>
                      </div>
                      {supportticket.Executor &&
                        <div className="st-detail-field">
                          <span className="st-detail-field-label">Ejecutor</span>
                          <span className="st-detail-field-value">{supportticket.Executor.fullname}</span>
                        </div>
                      }
                      {supportticket.ReviewedAt &&
                        <div className="st-detail-field">
                          <span className="st-detail-field-label">En Revisión</span>
                          <span className="st-detail-field-value">
                            {new Date(supportticket.ReviewedAt).toLocaleString()}
                            {supportticket.ReviewedBy ? ` — ${supportticket.ReviewedBy.fullname}` : ''}
                          </span>
                        </div>
                      }
                      {supportticket.InIncidenceAt &&
                        <div className="st-detail-field">
                          <span className="st-detail-field-label">En Incidencia</span>
                          <span className="st-detail-field-value">
                            {new Date(supportticket.InIncidenceAt).toLocaleString()}
                            {supportticket.InIncidenceBy ? ` — ${supportticket.InIncidenceBy.fullname}` : ''}
                          </span>
                        </div>
                      }
                      {supportticket.InRepairAt &&
                        <div className="st-detail-field">
                          <span className="st-detail-field-label">En Reparación</span>
                          <span className="st-detail-field-value">
                            {new Date(supportticket.InRepairAt).toLocaleString()}
                            {supportticket.InRepairBy ? ` — ${supportticket.InRepairBy.fullname}` : ''}
                          </span>
                        </div>
                      }
                      {supportticket.ResolvedAt &&
                        <div className="st-detail-field">
                          <span className="st-detail-field-label">Resuelto</span>
                          <span className="st-detail-field-value">
                            {new Date(supportticket.ResolvedAt).toLocaleString()}
                            {supportticket.ResolvedBy ? ` — ${supportticket.ResolvedBy.fullname}` : ''}
                          </span>
                        </div>
                      }
                      {supportticket.ClosedAt &&
                        <div className="st-detail-field">
                          <span className="st-detail-field-label">Cerrado</span>
                          <span className="st-detail-field-value">
                            {new Date(supportticket.ClosedAt).toLocaleString()}
                            {supportticket.ClosedBy ? ` — ${supportticket.ClosedBy.fullname}` : ''}
                          </span>
                        </div>
                      }
                    </div>
                  </div>
                </div>

                {/* Description */}
                <div className="st-detail-card" style={{ marginBottom: 16 }}>
                  <div className="st-detail-card-title">
                    <i className="fas fa-file-alt"></i> Descripción
                  </div>
                  <div className="st-detail-card-body">
                    <div className="st-detail-description">
                      {supportticket.Description || 'Sin descripción'}
                    </div>
                  </div>
                </div>

                {/* Actuation */}
                {supportticket.Actuation &&
                  <div className="st-detail-card" style={{ marginBottom: 16 }}>
                    <div className="st-detail-card-title">
                      <i className="fas fa-tools"></i> Actuación Realizada
                    </div>
                    <div className="st-detail-card-body">
                      <div className="st-detail-description">
                        {supportticket.Actuation}
                      </div>
                    </div>
                  </div>
                }

                {supportticket.Observations &&
                  <div className="st-detail-card" style={{ marginBottom: 16 }}>
                    <div className="st-detail-card-title">
                      <i className="fas fa-sticky-note"></i> Observaciones
                    </div>
                    <div className="st-detail-card-body">
                      <div className="st-detail-description">
                        {supportticket.Observations}
                      </div>
                    </div>
                  </div>
                }

                {/* Actions - New workflow */}
                {isAdmin && !isClosed &&
                  <div className="st-detail-actions-bar">
                    <h3><i className="fas fa-cogs"></i> Acciones</h3>
                    <div className="st-detail-actions-row justify-content-center">
                      {/* OPEN -> only Review button */}
                      {supportticket.Status === 'OPEN' &&
                        <button className="st-detail-action-btn review"
                          onClick={() => this.handleReviewTicket(supportticket._id)}>
                          <i className="fas fa-eye"></i>Revisar
                        </button>
                      }
                      {/* IN_REVIEW -> Resolve or Incidence */}
                      {supportticket.Status === 'IN_REVIEW' &&
                        <>
                          <button className="st-detail-action-btn resolve"
                            onClick={() => this.handleOpenResolveModal(supportticket._id)}>
                            <i className="fas fa-check"></i>Resolver
                          </button>
                          <button className="st-detail-action-btn incidence"
                            onClick={() => this.handleOpenIncidenceModal(supportticket._id)}>
                            <i className="fas fa-exclamation-triangle"></i>Poner en Incidencia
                          </button>
                        </>
                      }
                      {/* IN_INCIDENCE -> Repair */}
                      {supportticket.Status === 'IN_INCIDENCE' &&
                        <button className="st-detail-action-btn repair"
                          onClick={() => this.handleRepairTicket(supportticket._id)}>
                          <i className="fas fa-wrench"></i>Pasar a Reparación
                        </button>
                      }
                      {/* Close button - only for MASTER */}
                      {isMaster &&
                        <button className="st-detail-action-btn close-action"
                          onClick={() => this.handleCloseTicket(supportticket._id)}>
                          <i className="fas fa-times"></i>Cerrar
                        </button>
                      }
                    </div>
                  </div>
                }

                {/* Delete button - only for ADMIN MASTER */}
                {isAdmin && isMaster &&
                  <div className="st-detail-delete-row justify-content-center">
                    <button className="st-detail-delete-btn"
                      onClick={() => this.handleDeleteTicket(supportticket._id)}>
                      <i className="fas fa-trash"></i>Eliminar Ticket
                    </button>
                  </div>
                }
              </>
            )}
          </ModalBody>
        </Modal>

        {/* Actuation Modal for Resolve/Incidence */}
        <Modal isOpen={showActuationModal} toggle={() => this.setState({ showActuationModal: false, actuationText: '' })}>
          <ModalHeader toggle={() => this.setState({ showActuationModal: false, actuationText: '' })}>
            {actuationAction === 'resolve' ? 'Resolver Ticket' : 'Poner en Incidencia'}
          </ModalHeader>
          <ModalBody>
            <p>
              {actuationAction === 'resolve' 
                ? 'Describe la actuación realizada para resolver el ticket:' 
                : 'Describe el motivo por el que se pone en incidencia:'}
            </p>
            <textarea
              className="form-control"
              rows={4}
              value={actuationText}
              onChange={(e) => this.setState({ actuationText: e.target.value })}
              placeholder="Escribe la actuación realizada..."
            />
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.handleActuationSubmit}>
              {actuationAction === 'resolve' ? 'Resolver' : 'Poner en Incidencia'}
            </Button>
            <Button color="secondary" onClick={() => this.setState({ showActuationModal: false, actuationText: '' })}>
              Cancelar
            </Button>
          </ModalFooter>
        </Modal>
      </>
    )
  }

  renderSummaryPanel() {
    const { supporttickets } = this.props
    const counts = this.getStatusCounts()
    const categoryCounts = this.getCategoryCounts()
    const priorityCounts = this.getPriorityCounts()
    const total = supporttickets ? supporttickets.length : 0

    return (
      <div className="st-admin-summary-panel">
        {/* Status summary */}
        <div className="st-summary-card">
          <div className="st-summary-card-header">
            <h3><i className="fas fa-chart-pie"></i> Resumen por Estado</h3>
          </div>
          <div className="st-summary-card-body">
            <div className="st-summary-total">{total} tickets totales</div>
            <div className="st-summary-table">
              {['OPEN', 'IN_REVIEW', 'IN_INCIDENCE', 'IN_REPAIR', 'RESOLVED', 'CLOSED'].map(status => {
                const count = counts[status] || 0
                const pct = total > 0 ? Math.round((count / total) * 100) : 0
                return (
                  <div className="st-summary-row" key={status}
                    onClick={() => this.setState({ activeFilter: status })}>
                    <div className="st-summary-row-left">
                      <span className={`st-summary-dot ${status}`}></span>
                      <span className="st-summary-label">{STATUS_LABELS[status]}</span>
                    </div>
                    <div className="st-summary-row-right">
                      <span className="st-summary-count">{count}</span>
                      <div className="st-summary-bar-bg">
                        <div className={`st-summary-bar-fill ${status}`} style={{ width: `${pct}%` }}></div>
                      </div>
                      <span className="st-summary-pct">{pct}%</span>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>

        {/* Priority summary */}
        <div className="st-summary-card">
          <div className="st-summary-card-header">
            <h3><i className="fas fa-exclamation-triangle"></i> Por Prioridad</h3>
          </div>
          <div className="st-summary-card-body">
            <div className="st-summary-table">
              {['CRITICAL', 'HIGH', 'MEDIUM', 'LOW'].map(priority => {
                const count = priorityCounts[priority] || 0
                return (
                  <div className="st-summary-row" key={priority}>
                    <div className="st-summary-row-left">
                      <span className={`ticket-priority-badge ${priority}`} style={{ fontSize: 10 }}>
                        {PRIORITY_LABELS[priority]}
                      </span>
                    </div>
                    <div className="st-summary-row-right">
                      <span className="st-summary-count">{count}</span>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>

        {/* Category summary */}
        <div className="st-summary-card">
          <div className="st-summary-card-header">
            <h3><i className="fas fa-tags"></i> Por Categoría</h3>
          </div>
          <div className="st-summary-card-body">
            <div className="st-summary-table">
              {Object.entries(categoryCounts)
                .sort((a, b) => b[1] - a[1])
                .map(([cat, count]) => (
                  <div className="st-summary-row" key={cat}>
                    <div className="st-summary-row-left">
                      <span className="st-summary-label">{CATEGORY_LABELS[cat] || cat}</span>
                    </div>
                    <div className="st-summary-row-right">
                      <span className="st-summary-count">{count}</span>
                    </div>
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { role, supporttickets, error, loading } = this.props
    const { activeFilter } = this.state
    const counts = this.getStatusCounts()
    const filteredTickets = this.getFilteredTickets()

    return (
      <div className="support-ticket-admin-view">
        {/* Header */}
        <div className="st-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-headset mr-3"></i>
                Tickets de Soporte
              </h1>
            </div>
            <div className="header-actions">
              {role === 'ADMIN' &&
                <button className="st-admin-download-btn" onClick={this.handleDownload}>
                  <i className="fas fa-file-excel"></i>Descargar CSV
                </button>
              }
            </div>
          </div>
        </div>

        {/* Split layout - 2 columns below header */}
        <div className="st-admin-split">
          {/* LEFT — Filter + Ticket List */}
          <div className="st-admin-list-panel">
            {/* Filter */}
            <SupportTicketsFilterForm />
            
            <div className="ticket-filter-tabs">
              {FILTER_TABS.map(tab => (
                <button key={tab.key}
                  className={`ticket-filter-tab ${activeFilter === tab.key ? 'active' : ''}`}
                  onClick={() => this.setState({ activeFilter: tab.key })}>
                  {tab.label}
                  {tab.key !== 'ALL' && counts[tab.key] > 0 &&
                    <span style={{ marginLeft: 4 }}>({counts[tab.key]})</span>
                  }
                </button>
              ))}
            </div>

            {error ? (
              <ErrorMessage message={error.message} />
            ) : !supporttickets || loading ? (
              <LoadingProgress />
            ) : (
              <div className="st-admin-ticket-list">
                {filteredTickets.length > 0
                  ? filteredTickets.map(ticket => this.renderTicketCard(ticket))
                  : (
                    <div className="st-admin-empty">
                      <i className="fas fa-inbox"></i>
                      <p>No hay tickets {activeFilter !== 'ALL' ? `con estado "${STATUS_LABELS[activeFilter]}"` : ''}</p>
                    </div>
                  )
                }
              </div>
            )}
          </div>

          {/* RIGHT — Summary Panel */}
          {supporttickets && !loading && this.renderSummaryPanel()}
        </div>

        {/* Confirm close modal */}
        <Modal isOpen={this.state.closeConfirmShown}
          toggle={() => this.setState({ closeConfirmShown: false })}>
          <ModalHeader toggle={() => this.setState({ closeConfirmShown: false })}>
            Confirmar Cierre
          </ModalHeader>
          <ModalBody>
            <p>¿Estás seguro de cerrar el ticket #{this.state.closeId}?</p>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" className="mr-1" onClick={this.confirmClose}>Sí</Button>
            <Button color="secondary" onClick={() => this.setState({ closeConfirmShown: false })}>No</Button>
          </ModalFooter>
        </Modal>

        {/* Confirm delete modal */}
        <Modal isOpen={this.state.deleteConfirmShown}
          toggle={() => this.setState({ deleteConfirmShown: false })}>
          <ModalHeader toggle={() => this.setState({ deleteConfirmShown: false })}>
            Confirmar Eliminación
          </ModalHeader>
          <ModalBody>
            <p>¿Estás seguro de eliminar permanentemente el ticket #{this.state.deleteId}?</p>
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={this.confirmDelete}>Eliminar</Button>
            <Button color="secondary" onClick={() => this.setState({ deleteConfirmShown: false })}>Cancelar</Button>
          </ModalFooter>
        </Modal>

        {/* Ticket detail modal */}
        {this.renderDetailModal()}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  supporttickets: state.supporttickets.supporttickets,
  supportticket: state.supporttickets.supportticket,
  error: state.supporttickets.error,
  role: state.auth.role,
  type: state.auth.type,
  loading: state.supporttickets.loading,
  supportticketNeedRefresh: state.supporttickets.supportticketNeedRefresh,
  form: state.form
})

const mapDispatchToProps = dispatch => ({
  fetchSupportTickets: bindActionCreators(fetchSupportTickets, dispatch),
  fetchSupportTicket: bindActionCreators(fetchSupportTicket, dispatch),
  closeTicketSupport: bindActionCreators(closeTicketSupport, dispatch),
  reviewTicketSupport: bindActionCreators(reviewTicketSupport, dispatch),
  resolveTicketSupport: bindActionCreators(resolveTicketSupport, dispatch),
  incidenceTicketSupport: bindActionCreators(incidenceTicketSupport, dispatch),
  repairTicketSupport: bindActionCreators(repairTicketSupport, dispatch),
  deleteSupportTicket: bindActionCreators(deleteSupportTicket, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(SupportTicketsView)
